import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { useIntl } from "react-intl";
import { defaultLanguage } from "../i18n";
import {
  IoLogoFacebook,
  IoLogoInstagram,
  IoLogoLinkedin,
} from "react-icons/io";

const Footer = ({ siteTitle, wpMenu }) => {
  const intl = useIntl();
  const locale = defaultLanguage === intl.locale ? "/" : `/${intl.locale}/`;
  const footerItems = wpMenu
    .filter(
      (item) =>
        !!item.locations.includes(
          intl.locale === defaultLanguage
            ? "FOOTER_MENU"
            : `FOOTER_MENU___${intl.locale.toUpperCase()}`
        )
    )
    .map((item) =>
      item.menuItems.nodes.map((menu) => ({
        ...menu,
        url: menu.url.replace("/index.php", ""),
      }))
    )
    .flat();

  const data = useStaticQuery(graphql`
    query getCategories {
      allWpCategory {
        nodes {
          slug
          id
          name
          language {
            slug
          }
        }
      }
    }
  `);

  function checkCategories(category) {
    if (
      category.slug.startsWith("hero-post") || 
      category.slug.startsWith("uncategorized") || 
      category.slug.startsWith("non-classe") ||
      category.slug.startsWith("featured") || 
      category.slug.startsWith("custom") ||
      category.slug.startsWith("video")
    ){
      return false;
    } else {
      return category;
    }
  }

  const categoriesRaw = data.allWpCategory.nodes.filter(
    (category) => category.language.slug === intl.locale
  );
  const categories = categoriesRaw
    .filter((category) => checkCategories(category))
    .slice(0, 4);

  return (
    <footer className="footer" id="main-footer">
      <div className="footer__container">
        <div className="footer__column footer__column--social">
          <div className="footer__logo">
            <Link to={`${locale}`}>
              <div className="logo" />
            </Link>
          </div>
          <div className="footer__social">
            <ul className="footer__social-list">
              <li className="footer__social-list-item">
                <a
                  href="https://www.facebook.com/TrendsCatchers/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <IoLogoFacebook color="#fff" height="85px" />
                </a>
              </li>
              <li className="footer__social-list-item">
                <a
                  href={`https://www.instagram.com/trendscatchers/?hl=${intl.locale}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <IoLogoInstagram color="#fff" height="85px" />
                </a>
              </li>
              <li className="footer__social-list-item">
                <a
                  href="https://www.linkedin.com/company/boons-media/mycompany/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <IoLogoLinkedin color="#fff" height="85px" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__column">
          <div className="footer__menu">
            <div className="footer__menu-heading">
              <h3>Category</h3>
            </div>
            <nav className="footer__navigation" id="footer-navigation">
              <ul className="footer__navigation-list">
                {categories.map((item) => (
                  <li key={item.id} className="footer__navigation-list-item">
                    <Link
                      to={
                        process.env.GATSBY_MULTILINGUAL === "true"
                          ? `/${intl.locale}/category/${item.slug}/`
                          : `/${item.slug}/`
                      }
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        <div className="footer__column">
          <div className="footer__menu">
            <div className="footer__menu-heading">
              <h3>Legal</h3>
            </div>
            <nav className="footer__navigation" id="footer-navigation">
              <ul className="footer__navigation-list">
                {footerItems.map((item) => (
                  <li key={item.id} className="footer__navigation-list-item">
                    <Link to={`${item.url}`}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div className="footer__copyright">
        <div className="footer__copyright-inner">
          © {siteTitle} {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
